(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ow-header"]) return;
  try {
    
  document.querySelectorAll('.ow-header').forEach(function (section) {
    if (section.dataset.owHeaderReady === 'true') return;
    section.dataset.owHeaderReady = 'true';

    var toggle = section.querySelector('[data-ow-header-toggle]');
    var drawer = section.querySelector('[data-ow-header-drawer]');
    var overlay = section.querySelector('[data-ow-header-close]');
    var searchModal = document.getElementById('search-modal');
    var searchTriggers = section.querySelectorAll('[data-ow-search-trigger]');
    var searchUrl = section.dataset.searchUrl || '/search';

    function syncSearchState(expanded) {
      searchTriggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function closeMenu() {
      section.classList.remove('ow-header--menu-open');
      document.body.classList.remove('ow-header-body-lock');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
    }

    function refreshSearchEmptyState() {
      if (!searchModal) return Promise.resolve();

      var contentHost = searchModal.querySelector('.predictive-search-form__content');
      if (!contentHost || contentHost.dataset.owSearchFresh === 'true') {
        return Promise.resolve();
      }

      var refreshUrl = new URL(window.location.href);
      refreshUrl.searchParams.set('section_id', 'predictive-search-empty');
      refreshUrl.searchParams.set('v', String(Date.now()));
      contentHost.classList.add('ow-search-loading');

      return fetch(refreshUrl.toString(), { credentials: 'same-origin' })
        .then(function (response) {
          return response.text();
        })
        .then(function (markup) {
          var parsed = new DOMParser().parseFromString(markup, 'text/html');
          var freshResults = parsed.querySelector('.predictive-search-empty-section #predictive-search-results');
          if (freshResults) {
            contentHost.innerHTML = freshResults.outerHTML;
            contentHost.dataset.owSearchFresh = 'true';
          }
        })
        .catch(function () {
          return null;
        })
        .finally(function () {
          contentHost.classList.remove('ow-search-loading');
        });
    }

    function openMenu() {
      section.classList.add('ow-header--menu-open');
      document.body.classList.add('ow-header-body-lock');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
    }

    function openSearch() {
      closeMenu();

      if (searchModal && typeof searchModal.showDialog === 'function') {
        searchModal.showDialog();
        refreshSearchEmptyState().finally(function () {
          window.setTimeout(function () {
            var input = searchModal.querySelector('input[type="search"]');
            if (input) input.focus();
          }, 30);
        });
        return;
      }

      window.location.href = searchUrl;
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = section.classList.contains('ow-header--menu-open');
        if (isOpen) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    }

    if (overlay) {
      overlay.addEventListener('click', closeMenu);
    }

    if (drawer) {
      drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
    }

    searchTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', openSearch);
    });

    if (searchModal) {
      searchModal.addEventListener('dialog:open', function () {
        syncSearchState(true);
      });

      searchModal.addEventListener('dialog:close', function () {
        syncSearchState(false);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMenu();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 749) {
        closeMenu();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
